var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 41,
    viewBox: "0 0 43 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.689014 15.7381L21.5 0.618033L42.311 15.7381L34.3619 40.2029H8.6381L0.689014 15.7381Z",
    fill: "#F7C206",
    stroke: "#1F3560"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipCodeIcon);
export default __webpack_public_path__ + "static/media/zipCodeIcon.6f166a6e46227e72b9cabaa97b590430.svg";
export { ForwardRef as ReactComponent };